import React from 'react';
import { Icon } from '../icon/Icon.jsx';

/* The last element before the theme toggle, at FIXED COORDINATES on every screen
   at every breakpoint. --bg-surface, 1px --loss border, octagon-x in --loss. It is
   NEVER disabled, NEVER hidden behind a menu, and it NEVER moves — including when
   the mode pill changes width. On the phone view it becomes a 56px full-width
   button fixed to the bottom of the viewport in the thumb zone.

   ## The word is no longer a hover reveal

   Machined register, 2026-08-01, and this is a bug fix wearing a redesign's clothes.

   The control used to be 32px square with `STOP` collapsed to `width: 0`, expanding
   to 34px on hover. The header lays its right-hand group out with `margin-left: auto`,
   so a control that grows by 34px on hover moves *itself* 34px left, and takes the
   theme toggle with it. The one rule this component's own docstring states twice —
   **it never moves** — was broken by its only animation, and it was broken precisely
   when the pointer was on the way to it.

   So the width is fixed at 78px and the word is always there. Hover raises contrast
   and fills the background; it does not change the geometry. An emergency control that
   has to be hovered before it says what it does was the weaker design anyway: the
   operator reaching for this is not in a mood to hunt.

   The 56px phone variant is unchanged — it is full-width in a fixed thumb-zone bar and
   has nothing to push. */

export function KillSwitch({ onClick, phone = false, style }) {
  if (phone) {
    return (
      <button type="button" onClick={onClick} className="jmt-kill jmt-kill--phone jmt-press" style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 'var(--space-8)',
        width: '100%', height: 56, background: 'var(--bg-surface)', border: '1px solid var(--loss)',
        borderRadius: 'var(--radius-control)', color: 'var(--loss)', cursor: 'pointer',
        fontFamily: 'var(--font-ui)', fontSize: 'var(--body-size)', fontWeight: 600,
        letterSpacing: 'var(--label-tracking)', textTransform: 'uppercase', ...style,
      }}>
        <Icon name="octagon-x" size={20} />Emergency stop
      </button>
    );
  }
  return (
    <button type="button" onClick={onClick} aria-label="Kill switch — stop everything" className="jmt-kill jmt-press" style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 'var(--space-4)',
      height: 32, width: 78, flex: '0 0 78px', padding: '0 6px', background: 'var(--bg-surface)',
      border: '1px solid var(--loss)', borderRadius: 'var(--radius-control)', color: 'var(--loss)',
      boxShadow: 'var(--edge-highlight)',
      cursor: 'pointer', fontFamily: 'var(--font-ui)', fontSize: 'var(--label-size)',
      fontWeight: 'var(--label-weight)', letterSpacing: 'var(--label-tracking)', ...style,
    }}>
      <Icon name="octagon-x" size={16} />
      <span className="jmt-kill-word" style={{ whiteSpace: 'nowrap' }}>STOP</span>
      <style>{`
        /* Colour and fill only. Nothing here changes a dimension — see the note above. */
        .jmt-kill:hover{background:var(--loss);color:var(--bg-canvas);border-color:var(--loss)}
        .jmt-kill:focus-visible{outline:none;box-shadow:var(--focus-ring-inverse)}
      `}</style>
    </button>
  );
}
